module.exports = __webpack_public_path__ + "media/images/shapes/shape-1-b5208e2d8273b02afb8d4338723dc577.svg";